import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { useCSS } from '../../lib/hooks.js';

import ButtonCollection from './ButtonCollection.js';
import { SquaredButton } from './ActionButton.js';

const QtyPicker = (props) => {
	useCSS('comp/qty_picker.css');

	const default_units = props?.units ?? 1;

	const [ units, setUnits ] = useState(default_units);

	const max_units = props?.max_units ?? -1;	// "-1" for unlimited units

	if(max_units == 0 || max_units == 1) return null;

	const updateUnits = (_units) => {
		setUnits(_units);
		document.querySelector('.resumee').innerHTML = _units;
		if(props.onUpdateUnits != undefined) props.onUpdateUnits(_units);
	};

	// contentEditable items do NOT fire a onChange event,
	// so we need to do it with the onInput event.
	const onManuallyChange = (e) => {
		const new_value = parseInt(e.target.textContent);

		// if anything other than a number is entered, replace it with the default value:
		if(isNaN(new_value)) {
			updateUnits(default_units);
			return;
		}

		// unlimited units:
		if(max_units == -1) {
			updateUnits(new_value);
			return;
		}

		// update with the actual units (or its maximum, if overpassed):
		updateUnits(Math.min(max_units, new_value));
	};

	return (
		<div class="qty_picker">
			<ButtonCollection>
				<SquaredButton
					icon="knk-minus mainTextIcon"
					onClick={() => updateUnits(units - 1)}
					disabled={(units == 1) ? true : false}
				/>

				<span
					class="resumee"
					contentEditable={true}
					onInput={onManuallyChange}
				>{units}</span>

				<SquaredButton
					icon="knk-plus mainTextIcon"
					onClick={() => updateUnits(units + 1)}
					disabled={(max_units > -1 && units == max_units) ? true : false}
				/>
			</ButtonCollection>
		</div>
	);
}

export default injectIntl(QtyPicker);